import { locale } from "../locales/index.js";
import vuetify from "../plugins/vuetify.js";

// Доступные языки
const AVAILABLE_LANGUAGES = Object.keys(locale.messages);
const DEFAULT_LANGUAGE = "en";

// Получить язык из различных источников
function getPreferredLanguage() {
  // 1. Проверяем localStorage
  const savedLang = localStorage.getItem("language");
  if (savedLang && AVAILABLE_LANGUAGES.includes(savedLang)) {
    return savedLang;
  }

  // 2. Проверяем язык браузера
  const browserLang = navigator.language.split("-")[0];
  if (AVAILABLE_LANGUAGES.includes(browserLang)) {
    return browserLang;
  }

  // 3. Возвращаем язык по умолчанию
  return DEFAULT_LANGUAGE;
}

// Установить язык
function setLanguage(lang) {
  if (AVAILABLE_LANGUAGES.includes(lang)) {
    locale.locale = lang;
    localStorage.setItem("language", lang);
    vuetify.locale.current.value = lang;
    document.documentElement.setAttribute("lang", lang);
    return true;
  }
  return false;
}

// Middleware для проверки языка в маршрутах
function languageGuard(to, from, next) {
  const routeLang = to.params.lang;

  // Если язык указан в URL
  if (routeLang) {
    if (AVAILABLE_LANGUAGES.includes(routeLang)) {
      setLanguage(routeLang);
      next();
    } else {
      // Неправильный язык - редирект на правильный URL
      const preferredLang = getPreferredLanguage();
      const newPath = to.path.replace(`/${routeLang}`, `/${preferredLang}`);
      next(newPath);
    }
  } else {
    // Язык не указан - редирект с языком
    const preferredLang = getPreferredLanguage();
    setLanguage(preferredLang);
    next(`/${preferredLang}${to.path}${to.hash}`);
  }
}

const frontend_router = [
  {
    path: "/:lang",
    name: "home",
    component: () => import("../views/Home.vue"),
    beforeEnter: languageGuard,
  },
  {
    path: "/:lang/cart",
    name: "cart",
    component: () => import("../views/Cart.vue"),
    beforeEnter: languageGuard,
  },
  {
    path: "/:lang/collection/:collection_id?",
    name: "collection",
    component: () => import("../views/Collection.vue"),
    beforeEnter: languageGuard,
  },
  {
    path: "/:lang/product/:product_id?",
    name: "product",
    component: () => import("../views/Product.vue"),
    beforeEnter: languageGuard,
  },
  {
    path: "/:lang/principles",
    name: "principles",
    component: () => import("../views/Principles.vue"),
    beforeEnter: languageGuard,
  },
  {
    path: "/:lang/plants-care",
    name: "plants-care",
    component: () => import("../views/PlantsCare.vue"),
    beforeEnter: languageGuard,
  },
  {
    path: "/:lang/self-watering",
    name: "self-watering",
    component: () => import("../views/SelfWatering.vue"),
    beforeEnter: languageGuard,
  },
  {
    path: "/:lang/recycling",
    name: "recycling",
    component: () => import("../views/Recycling.vue"),
    beforeEnter: languageGuard,
  },
  {
    path: "/:lang/contact",
    name: "contact",
    component: () => import("../views/Contact.vue"),
    beforeEnter: languageGuard,
  },
  {
    path: "/:lang/about",
    name: "about",
    component: () => import("../views/About.vue"),
    beforeEnter: languageGuard,
  },
  {
    path: "/:lang/blog",
    name: "blog",
    component: () => import("../views/Blog.vue"),
    beforeEnter: languageGuard,
  },
  {
    path: "/:lang/blog/:article_id",
    name: "blog-article",
    component: () => import("../views/BlogArticle.vue"),
    beforeEnter: languageGuard,
  },
  {
    path: "/:lang/legal",
    name: "legal",
    component: () => import("../views/Legal.vue"),
    beforeEnter: languageGuard,
  },
  {
    path: "/:lang/hashtag/:slug",
    name: "hashtag",
    component: () => import("../views/HashtagPage.vue"),
    beforeEnter: languageGuard,
  },
  // Редирект с корня на главную с языком
  {
    path: "/",
    redirect: () => {
      const preferredLang = getPreferredLanguage();
      return `/${preferredLang}`;
    },
  },
];

export default frontend_router;